/* eslint-disable */
import React, { useState } from 'react';
import BossDialog from '../../components/BossDialog';
import { EditPageHeader } from '../../components/EditPageHeader';
import { useTranslation } from '../../locale/useTranslation';
import ActionButton from '../forms/helpercomponents/buttons/ActionButton';
import { ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, TOAST_TYPES } from '../constant/constant';
import * as API from '../API/api';
import moment from 'moment';
import { utility } from '../utility/utilityProvider';
import OttAssetCollectionSelection from './OttAssetCollectionSelection';
import ToastNotification from '../../components/ToastNotification';

const UpcomingEventEditForm = (props) => {

    const lang = useTranslation();
    const language = utility.getValue(LOCALSTORAGE_KEY.COMPANY)?.Language ?? { ISOCode: "en_US1" };
    const blankDataItem = {
        ...props?.item,
        StartDate: props?.item?.StartDate ? moment(new Date(props?.item?.StartDate)).format('YYYY-MM-DD') : moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
        LaunchDate: props?.item?.LaunchDate ? moment(new Date(props?.item?.LaunchDate)).format('YYYY-MM-DD') : moment().add(1, 'days').format('YYYY-MM-DD'),
        OttAsset: props?.item?.OttAsset ?? {},
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [ottAssetShow, setOttAssetShow] = useState(false);

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value })
    };

    const isValid = () => {
        if (!dataItem?.StartDate || dataItem?.StartDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please select start date' });
            return false;
        }
        if (!dataItem?.LaunchDate || dataItem?.LaunchDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please select launch date' });
            return false;
        }
        if (dataItem?.StartDate > dataItem?.LaunchDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Launch date should be greater than start date' });
            return false;
        }
        if (!dataItem?.OttAsset || Object.keys(dataItem?.OttAsset).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please select ott asset' });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {

        if (!isValid()) return;
        let finalData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            StartDate: dataItem?.StartDate ? utility.convertStringDatetoMilliseconds(dataItem?.StartDate) : 0,
            LaunchDate: dataItem?.LaunchDate ? utility.convertStringDatetoMilliseconds(dataItem?.LaunchDate) : 0,
            OttAsset: dataItem?.OttAsset && Object.keys(dataItem?.OttAsset).length > 0 ? {
                _id: dataItem?.OttAsset?._id,
                Title: dataItem?.OttAsset?.Title
            } : {},
        }
        console.log(finalData);
        const res = await API.saveData(ENTITYNAME.OttUpcomingEvents, finalData);
        if (!res.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        } else {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.UPCOMING_EVENTS, data: res.data, message: res.message };
            await API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.OttUpcomingEvents);
            props.cancelEdit();
            props.refresh();
        }
    }

    const handleAssetSelected = (item) => {
        setDataItem({ ...dataItem, OttAsset: item?.length > 0 ? item[0] : {} });
    }

    return (
        <>
            <BossDialog title={lang.upcoming_event_dialog_header} onClose={props.cancelEdit} width={"600px"}>
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row'>
                            <div className='col-6'>
                                <label htmlFor="TabView">{lang.start_date_lable} *</label>
                                <input
                                    className="form-control form-control-sm"
                                    name="StartDate"
                                    type="date"
                                    value={dataItem.StartDate}
                                    onChange={onChange}
                                />
                            </div>
                            <div className='col-6'>
                                <label htmlFor="TabView">{lang.launch_date_label} *</label>
                                <input
                                    className="form-control form-control-sm"
                                    type="date"
                                    name="LaunchDate"
                                    value={dataItem.LaunchDate}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <label htmlFor="assetInput" className='mt-2'>{lang.ott_asset_label} *</label>
                        <div className="d-flex align-items-center">
                            <input
                                id="OttAsset"
                                name="OttAsset"
                                type="text"
                                className="form-control form-control-sm"
                                value={
                                    Array.isArray(dataItem?.OttAsset?.Title)
                                        ? utility.getItemDisplayValueByLang(dataItem?.OttAsset?.Title, language)
                                        : dataItem?.OttAsset?.Title || ""
                                }
                                readOnly
                            />
                            <ActionButton
                                style={{ height: "30px" }}
                                btnColor="success"
                                title={lang.select_button_tooltip}
                                name="..."
                                onClick={() => setOttAssetShow(true)}
                            />
                            <ActionButton
                                style={{ height: "30px" }}
                                btnColor="danger"
                                title={lang.clear_button_tooltip}
                                name=""
                                icon="xmark"
                                onClick={() => setDataItem({ ...dataItem, OttAsset: {} })}
                            />
                        </div>
                    </div>
                </div>
                {ottAssetShow && <OttAssetCollectionSelection title={lang.select_button_text} addButtonTitle={lang.select_button_text} entityname={ENTITYNAME.OttAsset} closeForm={() => setOttAssetShow(false)} mode={"single"} width={"50vw"} setDataList={handleAssetSelected} />}
            </BossDialog>
        </>
    )
}

export default UpcomingEventEditForm;